import type { ReactNode } from 'react';
import { cn } from './cn.js';
import { Mascot, type MascotMood } from './Mascot.js';

export interface EmptyStateProps {
  icon?: ReactNode;
  /** Statt eines Emojis das Maskottchen zeigen — gibt leeren Zuständen ein Gesicht. */
  mascot?: MascotMood;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  mascot,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-16 px-6 rounded-2xl border border-dashed border-line bg-raise',
        className,
      )}
    >
      {mascot ? (
        <div className="mb-4">
          <Mascot mood={mascot} size={72} />
        </div>
      ) : (
        icon && <div className="text-5xl mb-4 opacity-80">{icon}</div>
      )}
      <h3 className="text-lg font-semibold text-text">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-text-dim max-w-sm leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
